// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".detail-bigimg .carousel__item img{width:100%;height:500px;-o-object-fit:cover;object-fit:cover;border-radius:8px}#thumbnails .carousel__item img{width:100%;height:250px;-o-object-fit:cover;object-fit:cover;border-radius:8px;cursor:pointer;transition:transform .2s ease}#thumbnails .carousel__item img:hover{transform:scale(1.05)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
